"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmailSubscriptionLinkField;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _hubl = require("../../utils/hubl");

var _link = require("../../constants/link");

var getTranslatedEmailSubscriptionLinkOptions = function getTranslatedEmailSubscriptionLinkOptions(emailSubscriptionLinkTypes) {
  return emailSubscriptionLinkTypes.map(function (linkType) {
    var _EmailSubscriptionLin = _link.EmailSubscriptionLinkOptions[linkType],
        text = _EmailSubscriptionLin.text,
        help = _EmailSubscriptionLin.help,
        value = _EmailSubscriptionLin.value;
    return {
      text: _I18n.default.text((0, _link.i18nKey)(text)),
      help: _I18n.default.text((0, _link.i18nKey)(help)),
      value: value
    };
  });
};

function EmailSubscriptionLinkField(props) {
  var href = props.href,
      onUpdate = props.onUpdate,
      dropdownClassName = props.dropdownClassName,
      emailSubscriptionLinkTypes = props.emailSubscriptionLinkTypes;
  return _react.default.createElement(_UIFormControl.default, {
    label: _I18n.default.text((0, _link.i18nKey)("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".label")),
    className: "m-top-0"
  }, _react.default.createElement(_UISelect.default, {
    dropdownClassName: dropdownClassName,
    searchable: true,
    value: (0, _hubl.getHublVariable)(href),
    onSelectedOptionChange: function onSelectedOptionChange(_ref) {
      var data = _ref.target.value;
      onUpdate({
        href: "{{ " + data.value + " }}",
        linkDisplayName: data.text
      });
    },
    options: getTranslatedEmailSubscriptionLinkOptions(emailSubscriptionLinkTypes),
    placeholder: _I18n.default.text((0, _link.i18nKey)("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".placeholder"))
  }));
}

EmailSubscriptionLinkField.propTypes = {
  onUpdate: _propTypes.default.func.isRequired,
  emailSubscriptionLinkTypes: _propTypes.default.array.isRequired,
  dropdownClassName: _propTypes.default.string,
  href: _propTypes.default.string
};
module.exports = exports.default;